import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M6.5 5c7.72 2.266 10.037 7.597 12.5 12.5","key":"svg-1"}],["path",{"d":"M17.5 5c-7.72 2.266 -10.037 7.597 -12.5 12.5","key":"svg-2"}]]

const IconBrandXbox = createReactComponent('outline', 'brand-xbox', 'BrandXbox', __iconNode);

export default IconBrandXbox;